var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_c('div',{staticClass:"hit-the-floor"},[_vm._v("404")]),_c('div',{staticClass:"sub-title"},[_vm._v("The Page Is Not Found")])])
}]

export { render, staticRenderFns }